import React from 'react'
import '../terms&ConditionComponent/termsandCondition.scss';

const TermsandCondition = () => {
  return (
    <section className="terms-container">
      <div className="terms-wrapper">
        <h1>Terms &amp; Conditions</h1>
        <p className="intro">
          Welcome to <strong>Brand Craft</strong>. These Terms &amp; Conditions
          (“Terms”) govern your use of our website and services. By accessing or
          using our website, you agree to comply with and be bound by these
          Terms. Please read them carefully before using our services.
        </p>

        <div className="terms-section">
          <h2>1. Use of Website</h2>
          <ul>
            <li>You agree to use this website only for lawful purposes.</li>
            <li>You must not misuse the website or attempt to gain unauthorized access.</li>
            <li>
              All content, text, graphics, and logos on this website are the
              property of Brand Craft unless stated otherwise.
            </li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>2. Services</h2>
          <p>
            Brand Craft provides digital marketing services including but not
            limited to social media management, SEO, advertising, content
            creation, and strategy consulting. The scope, timelines, and pricing
            of services will be mutually agreed upon and outlined in a separate
            agreement or proposal.
          </p>
        </div>

        <div className="terms-section">
          <h2>3. Payments & Refund Policy</h2>
          <ul>
            <li>All payments must be made as per the agreed terms in the proposal/contract.</li>
            <li>Payments are non-refundable unless otherwise specified in writing.</li>
            <li>Delay in payments may lead to suspension or termination of services.</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>4. Confidentiality</h2>
          <p>
            Both parties agree to maintain confidentiality of any sensitive or
            proprietary information shared during the course of work. Brand Craft
            will not share client data with third parties without prior consent,
            unless required by law.
          </p>
        </div>

        <div className="terms-section">
          <h2>5. Intellectual Property</h2>
          <p>
            All creative work, campaigns, and deliverables developed by Brand
            Craft remain the intellectual property of the agency until full
            payment is made. After payment, ownership of the final deliverables
            (excluding raw files, templates, or third-party assets) will be
            transferred to the client.
          </p>
        </div>

        <div className="terms-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            Brand Craft will not be liable for any direct, indirect, or
            incidental damages arising out of the use of our services. We do not
            guarantee specific results (e.g., sales, leads, or ranking) unless
            explicitly stated in a signed agreement.
          </p>
        </div>

        <div className="terms-section">
          <h2>7. Third-Party Services</h2>
          <p>
            Our services may involve the use of third-party platforms (e.g.,
            Google, Meta, Instagram, LinkedIn). We are not responsible for
            changes, downtime, or issues caused by these third-party services.
          </p>
        </div>

        <div className="terms-section">
          <h2>8. Termination of Services</h2>
          <p>
            Either party may terminate the agreement by giving prior written
            notice (as specified in the contract). Upon termination, all
            outstanding payments must be cleared immediately.
          </p>
        </div>

        <div className="terms-section">
          <h2>9. Governing Law</h2>
          <p>
            These Terms are governed by and construed in accordance with the laws
            of India. Any disputes shall be subject to the exclusive jurisdiction
            of the courts in Mumbai, Maharashtra.
          </p>
        </div>

        <div className="terms-section">
          <h2>10. Updates to Terms</h2>
          <p>
            Brand Craft reserves the right to modify these Terms at any time
            without prior notice. Continued use of the website or services
            constitutes acceptance of the updated Terms.
          </p>
        </div>

        <div className="terms-section">
          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us:
          </p>
          <address>
            <strong>Brand Craft</strong> <br />
            Mumbai, India <br />
            📧 Email:{" "}
            <a href="mailto:hello@brandcraftcreative.com">
              hello@brandcraftcreative.com
            </a>
            <br />
            📞 Phone: <a href="tel:+919136097310">9136097310</a>
          </address>
        </div>
      </div>
    </section>
  )
}

export default TermsandCondition;